export default class Slider {
  
  constructor() {
    this.cardSlider = document.querySelector('.card-slider'),
    this.headerSlider = document.querySelector('.header-slider'),
    this.boxesSlider = document.querySelector('.boxes-slider'),
    this.storeSlider = document.querySelector('.store-slider'),
    this.storeSliderLg = document.querySelector('.store-slider-lg'),
    this.marketplaceSlider = document.querySelector('.home-carousel'),
    this.productsSlider = document.querySelector('.products-slider'),
    this.careersSlider = document.querySelector('.careers-slider');

    this.initSliders();
    this.addResizeListener();
  }

  initSliders() {
    // homepage slider
    if (this.cardSlider) {
      this.initCardSlider();
    }
    if (this.headerSlider) {
      this.initHeaderSlider();
    }
    if (this.boxesSlider) {
      this.initBoxesSlider();
    }
    if (this.storeSlider) {
      this.initStoreSlider();
    }
    if (this.storeSliderLg) {
      this.initStoreSliderLg();
    }
    if (this.marketplaceSlider) { // replace with productsSlider
      this.initMarketplaceSlider();
    }
    if (this.productsSlider) {
      this.initProductsSlider();
    }
    if (this.careersSlider) {
      this.initCareersSlider();
    }
  }
  
  initCardSlider() {
    const shouldInitialize = window.innerWidth <= 991;
    
    if (shouldInitialize && !this.cardSliderInitialized) {
      // Initialize slider for mobile
      $(this.cardSlider).slick({
        arrows: false,
        autoplay: 0,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 576,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
      
      $(this.cardSlider).find('div').each(function() {
        $(this).attr('tabindex', '-1');
      });
      
      // Remove existing event listeners and add new ones
      $('.card-slider-prev').off('click.cardSlider').on('click.cardSlider', () => {
        $(this.cardSlider).slick('slickPrev');
      });
      
      $('.card-slider-next').off('click.cardSlider').on('click.cardSlider', () => {
        $(this.cardSlider).slick('slickNext');
      });
      
      this.cardSliderInitialized = true;
      
    } else if (!shouldInitialize && this.cardSliderInitialized) {
      // Destroy slider for desktop
      if ($(this.cardSlider).hasClass('slick-initialized')) {
        $(this.cardSlider).slick('unslick');
      }
      
      // Remove event listeners
      $('.card-slider-prev').off('click.cardSlider');
      $('.card-slider-next').off('click.cardSlider');
      
      // Remove tabindex attributes
      $(this.cardSlider).find('div').each(function() {
        $(this).removeAttr('tabindex');
      });
      
      this.cardSliderInitialized = false;
    }
  }
  
  initHeaderSlider() {
    $('.header-slider').slick({
      arrows: false,
      dots: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      appendDots: '#dots-container'
    });
  }
  initBoxesSlider() {
    $('.boxes-slider').slick({
      arrows: false,
      autoplay: 0,
      slidesToShow: 6,
      responsive: [
        {
          breakpoint: 1399,
          settings: {
            slidesToShow: 5
          }
        }, {
          breakpoint: 991,
          settings: {
            slidesToShow: 4
          }
        }, {
          breakpoint: 767,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 575,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
    $('.boxes-slider div').each(function() {
      $(this).attr('tabindex', '-1');
    });
    $('.boxes-slider-prev').each(function() {
      $(this).on('click', function() {
        $('.boxes-slider').slick('slickPrev');
      });
    });
    $('.boxes-slider-next').each(function() {
      $(this).on('click', function() {
        $('.boxes-slider').slick('slickNext');
      });
    });
  }
  initStoreSlider() {
    if (window.innerWidth <= '991') {
      $('.store-slider').slick({
        arrows: false,
        autoplay: 0,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 545,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
      $('.store-slider div').each(function() {
        $(this).attr('tabindex', '-1');
      });
      $('.store-slider-prev').each(function() {
        $(this).on('click', function() {
          $('.store-slider').slick('slickPrev');
        });
      });
      $('.store-slider-next').each(function() {
        $(this).on('click', function() {
          $('.store-slider').slick('slickNext');
        });
      });
    }
  }
  initStoreSliderLg() {
    if (window.innerWidth <= '1200') {
      $('.store-slider-lg').slick({
        arrows: false,
        autoplay: 0,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3
            }
          }, {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 545,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
      $('.store-slider div').each(function() {
        $(this).attr('tabindex', '-1');
      });
      $('.store-slider-prev').each(function() {
        $(this).on('click', function() {
          $('.store-slider').slick('slickPrev');
        });
      });
      $('.store-slider-next').each(function() {
        $(this).on('click', function() {
          $('.store-slider').slick('slickNext');
        });
      });
    }
  }
  initMarketplaceSlider() {
    $('.home-carousel').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: 0,
      arrow: true,
      dots: true,
    });
  }
  initProductsSlider() {
    $('.products-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: 0,
      arrow: true,
      dots: true,
    });
  }
  initCareersSlider() {
    $('.careers-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: 0,
      arrow: true,
      dots: true,
      responsive: [{
        breakpoint: 600,
        settings: {
          dots: false,
        }
      }]
    });
  }
  addResizeListener() {
    window.addEventListener('resize', () => {
      // Debounce resize events
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        if (this.cardSlider) {
          this.initCardSlider();
        }
      }, 250);
    });
  }
}